import { useQuery } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { listMcpServers } from '@/services/mcp-gateway';
import type { McpServer } from '@/services/mcp-gateway';

export function useMcpServers() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery<McpServer[]>({
    queryKey: ['mcp-servers', orgId],
    queryFn: () => listMcpServers(orgId),
    enabled: !!orgId,
    retry: false,
  });
}
